import PropTypes from 'prop-types';

// Used in CreateGame
export const PlayerMinimalPropType = PropTypes.shape({
    id: PropTypes.number.isRequired,
    category: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    selected: PropTypes.bool, // not required, so that it will be defaulted to false
});

export const CreateGameFormPropTypes = PropTypes.shape({
    activeCourse: PropTypes.number,
    activePlayers: PropTypes.arrayOf(PropTypes.number),
});

export const CoursePropTypes = PropTypes.shape({
    city: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    county: PropTypes.string.isRequired,
    created: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    distance: PropTypes.string,
    id: PropTypes.number.isRequired,
    image_url: PropTypes.string.isRequired,
    last_updated: PropTypes.string.isRequired,
    latitude: PropTypes.string,
    longitude: PropTypes.string,
    name: PropTypes.string.isRequired,
    par: PropTypes.number.isRequired,
    tee_count: PropTypes.number.isRequired,
    public: PropTypes.bool.isRequired,
    slug: PropTypes.string.isRequired,
});

export const NavbarSearchPropTypes = PropTypes.shape({
    isOpen: PropTypes.bool.isRequired,
    players: PropTypes.arrayOf(PlayerMinimalPropType),
    courses: PropTypes.arrayOf(CoursePropTypes),
    query: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['', 'PLAYERS', 'COURSE']),
});

export const TeamPropTypes = PropTypes.shape({
    active: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
});

export const BasketPropTypes = PropTypes.shape({
    active: PropTypes.bool.isRequired,
    id: PropTypes.number.isRequired,
    par: PropTypes.number.isRequired,
    number: PropTypes.number.isRequired,
    visible_number: PropTypes.string.isRequired,
    gameId: PropTypes.number,
    results: PropTypes.arrayOf(PropTypes.shape({
        ob: PropTypes.number,
        result: PropTypes.number,
        team: PropTypes.number.isRequired,
    })),
});

export const createUserInfoPropType = PropTypes.shape({});



// WEBPACK FOOTER //
// ./src/utils/propTypes.js